import { createSlice, isAnyOf, PayloadAction } from '@reduxjs/toolkit';

import { appConfigApi } from '#services/app';
import { inventoryApi } from '#services/inventory';
import { orderApi } from '#services/order';
import { productApi } from '#services/product';
import { receivingApi } from '#services/receiving';
import { managementApi } from '#services/user';
import { cartApi } from '#services/cart';

export interface AppConfigState {
  locale: string;
  ready?: boolean;
  loading?: boolean;
  loginFormPosition?: string;
  loginBgImage?: string;
  loginFormHideLogo?: boolean;
  wholesaleName?: string;
  wholesaleLogo?: string;
  wholesaleEmail?: string;
  wholesaleLogoDisplayFilename?: string;
  sizeChartImageDisplayFilename?: string;
  loginBgImageDisplayFilename?: string;
  [key: string]: unknown;
}

const initialState: AppConfigState = { locale: 'en' };

export const appConfigSlice = createSlice({
  name: 'appConfig',
  initialState,
  reducers: {
    setLocale: (state, action: PayloadAction<string>) => {
      state.locale = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(appConfigApi.endpoints.saveAppConfig.matchFulfilled, (state, action) => {
        return {
          ...state,
          ...action.payload,
          ready: true,
          loading: false,
        };
      })
      .addMatcher(appConfigApi.endpoints.getAppConfigForSite.matchFulfilled, (state, action) => {
        return {
          ...state,
          ...action.payload,
          ready: true,
          loading: false,
        };
      })
      .addMatcher(isAnyOf(
        orderApi.endpoints.getOrders.matchPending,
        orderApi.endpoints.getBulkOrders.matchPending,
        inventoryApi.endpoints.getInventoryOrders.matchPending,
        inventoryApi.endpoints.getInventoryReport.matchPending,
        inventoryApi.endpoints.getInventorySalesReport.matchPending,
        productApi.endpoints.getProducts.matchPending,
        productApi.endpoints.getProduct.matchPending,
        receivingApi.endpoints.getReceivings.matchPending,
        managementApi.endpoints.getUsers.matchPending,
        cartApi.endpoints.clearCart.matchPending,
      ), (state) => {
        return {
          ...state,
          loading: true,
        };
      })
      .addMatcher(isAnyOf(
        orderApi.endpoints.getOrders.matchRejected,
        orderApi.endpoints.getOrders.matchFulfilled,
        orderApi.endpoints.getBulkOrders.matchRejected,
        orderApi.endpoints.getBulkOrders.matchFulfilled,

        inventoryApi.endpoints.getInventoryOrders.matchRejected,
        inventoryApi.endpoints.getInventoryOrders.matchFulfilled,
        inventoryApi.endpoints.getInventoryReport.matchRejected,
        inventoryApi.endpoints.getInventoryReport.matchFulfilled,
        inventoryApi.endpoints.getInventorySalesReport.matchRejected,
        inventoryApi.endpoints.getInventorySalesReport.matchFulfilled,

        productApi.endpoints.getProducts.matchRejected,
        productApi.endpoints.getProducts.matchFulfilled,
        productApi.endpoints.getProduct.matchRejected,
        productApi.endpoints.getProduct.matchFulfilled,

        receivingApi.endpoints.getReceivings.matchRejected,
        receivingApi.endpoints.getReceivings.matchFulfilled,

        managementApi.endpoints.getUsers.matchRejected,
        managementApi.endpoints.getUsers.matchFulfilled,

        cartApi.endpoints.clearCart.matchRejected,
        cartApi.endpoints.clearCart.matchFulfilled,
      ), (state) => {
        return {
          ...state,
          loading: false,
        };
      });
  },
});

export const {
  setLocale,
} = appConfigSlice.actions;

export default appConfigSlice.reducer;
